document.addEventListener('DOMContentLoaded', () => {
  /**************************************************************
   * Inicializa todos los sliders "image-responsive" de la página
   * (soporta múltiples secciones)
   */
  document.querySelectorAll('.image-responsive-swiper').forEach(swiperEl => {
    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const sliderComponent = swiperEl.closest('slider-component');

    if (!sliderComponent) return;

    /* ===============================
       CASO 1: SOLO 1 SLIDE
       =============================== */
    if (slides.length <= 1) {
      swiperEl.classList.add('swiper-static');

      const pagination = swiperEl.querySelector('.swiper-pagination');
      if (pagination) pagination.style.display = 'none';

      return; // 🚫 NO inicializar Swiper
    }

    /* ===============================
       CASO 2: 2+ SLIDES → SWIPER ACTIVO
       =============================== */
    const autoplay = sliderComponent.dataset.autoplay === 'true';
    const delay = parseInt(sliderComponent.dataset.delayspeed, 10);
    const effect = sliderComponent.dataset.effects || 'slide';

    new Swiper(swiperEl, {
      loop: true,
      autoplay: autoplay ? { delay } : false,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      effect: effect
    });
  });
});